/*
 *
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _require = require('../command_util'),
  createTooltip = _require.createTooltip,
  returnEmptyArr = _require.returnEmptyArr,
  getExpectedData = _require.getExpectedData;
(function (c) {
  var _Entry$STATIC = Entry.STATIC,
    COMMAND_TYPES = _Entry$STATIC.COMMAND_TYPES,
    RECORDABLE = _Entry$STATIC.RECORDABLE;
  var variableContainerSelectFilter = COMMAND_TYPES.variableContainerSelectFilter,
    variableContainerClickVariableAddButton = COMMAND_TYPES.variableContainerClickVariableAddButton,
    variableContainerAddVariable = COMMAND_TYPES.variableContainerAddVariable,
    variableAddSetName = COMMAND_TYPES.variableAddSetName,
    variableContainerRemoveVariable = COMMAND_TYPES.variableContainerRemoveVariable,
    variableContainerAddMessage = COMMAND_TYPES.variableContainerAddMessage,
    variableContainerRemoveMessage = COMMAND_TYPES.variableContainerRemoveMessage,
    messageSetName = COMMAND_TYPES.messageSetName,
    variableAddSetScope = COMMAND_TYPES.variableAddSetScope,
    variableAddSetCloud = COMMAND_TYPES.variableAddSetCloud,
    variableSetVisibility = COMMAND_TYPES.variableSetVisibility,
    variableSetDefaultValue = COMMAND_TYPES.variableSetDefaultValue,
    variableSetSlidable = COMMAND_TYPES.variableSetSlidable,
    variableSetMinValue = COMMAND_TYPES.variableSetMinValue,
    variableSetMaxValue = COMMAND_TYPES.variableSetMaxValue,
    variableContainerClickListAddButton = COMMAND_TYPES.variableContainerClickListAddButton,
    variableContainerAddList = COMMAND_TYPES.variableContainerAddList,
    variableContainerRemoveList = COMMAND_TYPES.variableContainerRemoveList,
    listAddSetName = COMMAND_TYPES.listAddSetName,
    listAddSetScope = COMMAND_TYPES.listAddSetScope,
    listAddSetCloud = COMMAND_TYPES.listAddSetCloud,
    listSetVisibility = COMMAND_TYPES.listSetVisibility,
    listChangeLength = COMMAND_TYPES.listChangeLength,
    listSetDefaultValue = COMMAND_TYPES.listSetDefaultValue,
    setMessageEditable = COMMAND_TYPES.setMessageEditable,
    setVariableEditable = COMMAND_TYPES.setVariableEditable,
    setListEditable = COMMAND_TYPES.setListEditable,
    variableSetName = COMMAND_TYPES.variableSetName,
    listSetName = COMMAND_TYPES.listSetName,
    variableContainerClickMessageAddButton = COMMAND_TYPES.variableContainerClickMessageAddButton;
  c[variableContainerSelectFilter] = {
    "do": function _do(newType) {
      getVC().selectFilter(newType);
    },
    state: function state(newType, oldType) {
      return [oldType, newType];
    },
    log: function log(newType) {
      var oldType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
      return [['newType', newType], ['oldType', oldType]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableContainerSelectFilter',
    dom: ['variableContainer', 'filter', '&0']
  };
  c[variableContainerClickVariableAddButton] = {
    "do": function _do() {
      getVC().clickVariableAddButton();
    },
    state: returnEmptyArr,
    log: returnEmptyArr,
    recordable: RECORDABLE.SUPPORT,
    get undo() {
      try {
        getVC()._getAddPanel().view.name.value = '';
      } catch (e) {}
      return 'variableContainerClickVariableAddButton';
    },
    dom: ['variableContainer', 'variableAddButton']
  };
  c[variableContainerClickMessageAddButton] = {
    "do": function _do() {
      getVC().clickMessageAddButton();
    },
    state: returnEmptyArr,
    log: returnEmptyArr,
    recordable: RECORDABLE.SUPPORT,
    get undo() {
      try {
        getVC()._getAddPanel().view.name.value = '';
      } catch (e) {}
      return 'variableContainerClickMessageAddButton';
    },
    dom: ['variableContainer', 'variableAddButton']
  };
  c[variableContainerAddVariable] = {
    "do": function _do(variable) {
      var id = _.result(getExpectedData('variable'), 'id');
      if (id) {
        variable.id_ = id;
      }
      getVC().addVariable(variable);
    },
    state: function state(variable) {
      variable = _toJSON(variable);
      variable.id = _.result(getExpectedData('variable'), 'id') || variable.id;
      return [variable];
    },
    log: function log(variable) {
      return [['variable', _toJSON(variable)]];
    },
    recordable: RECORDABLE.SUPPORT,
    validate: false,
    undo: 'variableContainerRemoveVariable',
    restrict: function restrict(data, domQuery, callback) {
      getVC().clickVariableAddButton(true, true);
      $('.entryVariableAddSpaceInputWorkspace').val(_.result(getExpectedData('variable'), 'name') || '');
      var _data$tooltip = data.tooltip,
        title = _data$tooltip.title,
        content = _data$tooltip.content;
      callback();
      return createTooltip(title, content, domQuery, callback);
    },
    dom: ['variableContainer', 'variableAddConfirmButton']
  };
  c[variableAddSetName] = {
    "do": function _do(value) {
      var dom = c[variableAddSetName].dom;
      dom = Entry.getDom(dom);
      dom._focused = false;
      dom.value = getExpectedData('value', value);
    },
    state: function state() {
      return [''];
    },
    log: function log(value) {
      return [['value', getExpectedData('value', value)]];
    },
    restrict: function restrict(data, domQuery, callback) {
      getVC().clickVariableAddButton(true);
      var dom = Entry.getDom(this.dom);
      Entry.Utils.focusIfNotActive(dom);
      dom.enterKeyDisabled = true;
      var _data$tooltip2 = data.tooltip,
        title = _data$tooltip2.title,
        content = _data$tooltip2.content;
      return createTooltip(title, content, domQuery, callback, {
        noDispose: true
      });
    },
    validate: false,
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableAddSetName',
    dom: ['variableContainer', 'variableAddInput']
  };
  c[variableContainerRemoveVariable] = {
    "do": function _do(variable) {
      getVC().removeVariable(variable);
    },
    state: function state(variable) {
      return [_toJSON(variable)];
    },
    log: function log(variable) {
      return [['variable', _toJSON(variable)]];
    },
    recordable: RECORDABLE.SUPPORT,
    validate: false,
    undo: 'variableContainerAddVariable',
    dom: ['variableContainer', 'variableAddConfirmButton']
  };
  c[variableContainerAddMessage] = {
    "do": function _do(message) {
      message.id = _.result(getExpectedData('message'), 'id') || message.id;
      getVC().addMessage(message);
    },
    state: function state(message) {
      message.id = _.result(getExpectedData('message'), 'id') || message.id;
      return [message];
    },
    log: function log(_ref) {
      var name = _ref.name,
        id = _ref.id;
      return [['message', {
        name: name,
        id: id
      }]];
    },
    validate: false,
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableContainerRemoveMessage',
    dom: ['variableContainer', 'messageAddButton']
  };
  c[variableContainerRemoveMessage] = {
    "do": function _do(_ref2) {
      var id = _ref2.id;
      var VC = getVC();
      VC.removeMessage(VC.getMessage(id));
    },
    state: function state(_ref3) {
      var id = _ref3.id,
        name = _ref3.name;
      return [{
        id: id,
        name: name
      }];
    },
    log: function log(_ref4) {
      var id = _ref4.id,
        name = _ref4.name;
      return [['message', {
        name: name,
        id: id
      }]];
    },
    validate: false,
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableContainerAddMessage',
    dom: ['variableContainer', 'messageAddButton']
  };
  c[messageSetName] = {
    "do": function _do(id, newName) {
      var VC = getVC();
      var message = VC.getMessage(id);
      var nameField = message.listElement.nameField;
      nameField._focused = false;
      VC.changeMessageName(message, newName);
    },
    state: function state(id) {
      var _getVC$getMessage = getVC().getMessage(id),
        name = _getVC$getMessage.name;
      return [id, name];
    },
    log: function log(id, newName) {
      return [['id', id], ['newName', newName]];
    },
    restrict: function restrict(data, domQuery, callback) {
      var _data$tooltip3 = data.tooltip,
        title = _data$tooltip3.title,
        content = _data$tooltip3.content;
      callback();
      var VC = getVC();
      var message = VC.getMessage(domQuery[2]);
      delete message.listElement.nameField.isFirst;
      VC.activateMessageEditView(message);
      return createTooltip(title, content, domQuery, callback);
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'messageSetName',
    dom: ['variableContainer', 'messageList', '&0']
  };
  c[variableAddSetScope] = {
    "do": function _do() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'global';
      var isCloud = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var VC = getVC();
      var info = VC.variableAddPanel.info;
      if (type === 'global') {
        info.object = null;
        info.isCloud = isCloud;
      } else if (type === 'local') {
        var object = Entry.playground.object;
        if (!object) {
          return;
        }
        info.object = object.id;
        info.isCloud = false;
      }
      VC.updateVariableAddView('variable');
    },
    state: function state() {
      var _getVC = getVC(),
        _getVC$variableAddPan = _getVC.variableAddPanel,
        object = _getVC$variableAddPan.object,
        isCloud = _getVC$variableAddPan.isCloud;
      return [object ? 'local' : 'global', isCloud];
    },
    log: function log(type) {
      return [['type', type]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableAddSetScope',
    dom: ['variableContainer', 'variableScope', '&0']
  };
  c[variableAddSetCloud] = {
    "do": function _do(type) {
      var VC = getVC();
      var isCloud;
      var isRealTime;
      if (type === 'cloud') {
        isCloud = true;
      } else if (type === 'real_time') {
        isRealTime = true;
      }
      VC.variableAddPanel.info.isCloud = isCloud;
      VC.variableAddPanel.info.isRealTime = isRealTime;
      VC.updateVariableAddView('variable');
    },
    state: function state() {
      var _getVC2 = getVC(),
        _getVC2$variableAddPa = _getVC2.variableAddPanel.info,
        isCloud = _getVC2$variableAddPa.isCloud,
        isRealTime = _getVC2$variableAddPa.isRealTime;
      return [isCloud, isRealTime];
    },
    log: function log(type) {
      return [['type', type]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableAddSetCloud',
    dom: ['variableContainer', 'variableCloud']
  };
  c[variableSetVisibility] = {
    "do": function _do(id, value) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      variable.setVisible(value);
      VC.updateVariableSettingView(variable);
    },
    state: function state(id) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      return [id, variable.isVisible()];
    },
    log: function log(id, value) {
      return [['id', id], ['value', value]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableSetVisibility',
    dom: ['variableContainer', 'variableSetVisibility']
  };
  c[variableSetDefaultValue] = {
    "do": function _do(id, value) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      Entry.getDom(['variableContainer', 'variableSetDefaultValue'])._focused = false;
      variable.setValue(value);
      VC.updateVariableSettingView(variable);
    },
    state: function state(id) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      return [id, variable.getValue()];
    },
    log: function log(id, value) {
      return [['id', id], ['value', value]];
    },
    restrict: function restrict(_ref5, domQuery, callback) {
      var tooltip = _ref5.tooltip;
      var tooltipTitle = tooltip.title,
        tooltipContent = tooltip.content;
      return createTooltip(tooltipTitle, tooltipContent, domQuery, callback, {
        noDispose: true
      });
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableSetDefaultValue',
    dom: ['variableContainer', 'variableSetDefaultValue']
  };
  c[variableSetSlidable] = {
    "do": function _do(id, type, cValue) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      VC.setVariableSlidable(variable, type, cValue);
    },
    state: function state(id) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      return [id, variable.getType(), variable.getValue()];
    },
    log: function log(id, value) {
      return [['id', id], ['value', value]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableSetSlidable',
    dom: ['variableContainer', 'slideCheck']
  };
  c[variableSetMinValue] = {
    "do": function _do(id, value) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      variable.setMinValue(value);
      VC.updateVariableSettingView(variable);
    },
    state: function state(id) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      return [id, variable.getMinValue()];
    },
    log: function log(id) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      return [['id', id], ['value', variable.getMinValue()]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableSetMinValue',
    dom: ['variableContainer', 'variableMinValue']
  };
  c[variableSetMaxValue] = {
    "do": function _do(id, value) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      variable.setMaxValue(value);
      VC.updateVariableSettingView(variable);
    },
    state: function state(id) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      return [id, variable.getMaxValue()];
    },
    log: function log(id) {
      var VC = getVC();
      var variable = VC.getVariable(id);
      return [['id', id], ['value', variable.getMaxValue()]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableSetMaxValue',
    dom: ['variableContainer', 'variableMaxValue']
  };
  c[variableContainerClickListAddButton] = {
    "do": function _do() {
      getVC().clickListAddButton();
    },
    state: returnEmptyArr,
    log: returnEmptyArr,
    recordable: RECORDABLE.SUPPORT,
    get undo() {
      try {
        getVC()._getAddPanel('list').view.name.value = '';
      } catch (e) {}
      return 'variableContainerClickListAddButton';
    },
    dom: ['variableContainer', 'listAddButton']
  };
  c[variableContainerAddList] = {
    "do": function _do(list) {
      var id = _.result(getExpectedData('list'), 'id');
      if (id) {
        if (list.setId) {
          list.setId(id);
        } else {
          list.id = id;
        }
      }
      getVC().addList(list);
    },
    state: function state(list) {
      list = _toJSON(list);
      list.id = _.result(getExpectedData('list'), 'id') || list.id;
      return [list];
    },
    log: function log(list) {
      list = _toJSON(list);
      list.id = _.result(getExpectedData('list'), 'id') || list.id;
      return [['list', list]];
    },
    recordable: RECORDABLE.SUPPORT,
    validate: false,
    undo: 'variableContainerRemoveList',
    restrict: function restrict(data, domQuery, callback) {
      getVC().clickListAddButton(true, true);
      Entry.getDom(['variableContainer', 'listAddInput']).value = _.result(getExpectedData('list'), 'name') || '';
      var _data$tooltip4 = data.tooltip,
        title = _data$tooltip4.title,
        content = _data$tooltip4.content;
      callback();
      return createTooltip(title, content, domQuery, callback);
    },
    dom: ['variableContainer', 'listAddConfirmButton']
  };
  c[variableContainerRemoveList] = {
    "do": function _do(list) {
      getVC().removeList(list);
    },
    state: function state(list) {
      return [_toJSON(list)];
    },
    log: function log(list) {
      return [['list', _toJSON(list)]];
    },
    recordable: RECORDABLE.SUPPORT,
    validate: false,
    undo: 'variableContainerAddList',
    dom: ['variableContainer', 'listAddConfirmButton']
  };
  c[listAddSetName] = {
    "do": function _do(value) {
      var dom = c[listAddSetName].dom;
      dom = Entry.getDom(dom);
      dom._focused = false;
      dom.value = getExpectedData('value', value);
    },
    state: function state() {
      return [''];
    },
    log: function log(value) {
      return [['value', getExpectedData('value', value)]];
    },
    restrict: function restrict(data, domQuery, callback) {
      getVC().clickListAddButton(true);
      var dom = Entry.getDom(this.dom);
      Entry.Utils.focusIfNotActive(dom);
      dom.enterKeyDisabled = true;
      var _data$tooltip5 = data.tooltip,
        title = _data$tooltip5.title,
        content = _data$tooltip5.content;
      return createTooltip(title, content, domQuery, callback, {
        noDispose: true
      });
    },
    validate: false,
    recordable: RECORDABLE.SUPPORT,
    undo: 'listAddSetName',
    dom: ['variableContainer', 'listAddInput']
  };
  c[listAddSetScope] = {
    "do": function _do() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'global';
      var isCloud = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var VC = getVC();
      var info = VC.listAddPanel.info;
      if (type === 'global') {
        info.object = null;
        info.isCloud = isCloud;
      } else if (type === 'local') {
        var object = Entry.playground.object;
        if (!object) {
          return;
        }
        info.object = object.id;
        info.isCloud = false;
      }
      VC.updateVariableAddView('list');
    },
    state: function state() {
      var _getVC3 = getVC(),
        _getVC3$listAddPanel = _getVC3.listAddPanel,
        object = _getVC3$listAddPanel.object,
        isCloud = _getVC3$listAddPanel.isCloud;
      return [object ? 'local' : 'global', isCloud];
    },
    log: function log(type) {
      return [['type', type]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'listAddSetScope',
    dom: ['variableContainer', 'listScope', '&0']
  };
  c[listAddSetCloud] = {
    "do": function _do(type) {
      var VC = getVC();
      var isCloud;
      var isRealTime;
      if (type === 'cloud') {
        isCloud = true;
      } else if (type === 'real_time') {
        isRealTime = true;
      }
      VC.listAddPanel.info.isCloud = isCloud;
      VC.listAddPanel.info.isRealTime = isRealTime;
      VC.updateVariableAddView('list');
    },
    state: function state() {
      var _getVC4 = getVC(),
        _getVC4$listAddPanel$ = _getVC4.listAddPanel.info,
        isCloud = _getVC4$listAddPanel$.isCloud,
        isRealTime = _getVC4$listAddPanel$.isRealTime;
      return [isCloud, isRealTime];
    },
    log: function log(type) {
      return [['type', type]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'listAddSetCloud',
    dom: ['variableContainer', 'listCloud']
  };
  c[listSetVisibility] = {
    "do": function _do(id, value) {
      var VC = getVC();
      var list = VC.getList(id);
      list.setVisible(value);
      VC.updateListSettingView(list);
    },
    state: function state(id) {
      return [id, getVC().getList(id).isVisible()];
    },
    log: function log(id, value) {
      return [['id', id], ['value', value]];
    },
    restrict: _listActiveRestrictor,
    recordable: RECORDABLE.SUPPORT,
    undo: 'listSetVisibility',
    dom: ['variableContainer', 'listSetVisibility']
  };
  c[listChangeLength] = {
    "do": function _do(id, value) {
      return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var VC, list, length, result;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              VC = getVC();
              list = VC.getList(id);
              length = list.getArray().length;
              if (!(value === 'minus')) {
                _context.next = 2;
                break;
              }
              result = Math.max(0, length - 1);
              _context.next = 1;
              return list.deleteValue(result);
            case 1:
              _context.next = 5;
              break;
            case 2:
              if (!(value === 'plus')) {
                _context.next = 4;
                break;
              }
              result = length + 1;
              _context.next = 3;
              return list.appendValue(0);
            case 3:
              _context.next = 5;
              break;
            case 4:
              if (Entry.Utils.isNumber(value) && value >= 0) {
                result = value;
              } else {
                result = length;
              }
            case 5:
              VC.setListLength(list, result);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    state: function state(id) {
      return [id, getVC().getList(id).array_.length];
    },
    log: function log(id, value) {
      return [['id', id], ['value', value], ['dom', Entry.Utils.isNumber(value) ? 'lengthInput' : value]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'listChangeLength',
    restrict: function restrict(_ref6, domQuery, callback) {
      var tooltip = _ref6.tooltip,
        content = _ref6.content;
      _updateSelected(content);
      var tooltipTitle = tooltip.title,
        tooltipContent = tooltip.content;
      return createTooltip(tooltipTitle, tooltipContent, domQuery, callback, {
        noDispose: true
      });
    },
    dom: ['variableContainer', 'listChangeLength', '&2']
  };
  c[listSetDefaultValue] = {
    "do": function _do(id) {
      var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
      var VC = getVC();
      var list = VC.getList(id);
      list.getArray()[idx] = {
        data: data
      };
      VC.updateListSettingView();
      //list.updateView();
    },
    state: function state(id, idx) {
      var _getVC$getList = getVC().getList(id),
        array_ = _getVC$getList.array_;
      return [id, idx, array_[idx].data];
    },
    log: function log(id, idx, data) {
      return [['id', id], ['idx', idx], ['data', data]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'listSetDefaultValue',
    restrict: function restrict(data, domQuery, callback) {
      _updateSelected(data.content);
      Entry.Utils.focusIfNotActive(Entry.getDom(domQuery));
      var _data$tooltip6 = data.tooltip,
        title = _data$tooltip6.title,
        content = _data$tooltip6.content;
      return createTooltip(title, content, domQuery, callback, {
        noDispose: true
      });
    },
    dom: ['variableContainer', 'listDefaultValue', '&1']
  };
  c[setMessageEditable] = {
    "do": function _do(id) {
      var VC = getVC();
      var message = VC.getMessage(id);
      VC.activateMessageEditView(message);
      message.listElement.removeClass('activeForce');
    },
    state: function state(id) {
      return [id];
    },
    log: function log(id) {
      return [['id', id]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'setMessageEditable',
    restrict: function restrict(data, domQuery, callback) {
      Entry.Utils.blur();
      getVC().getMessage(data.content[1][1]).listElement.addClass('activeForce');
      var _data$tooltip7 = data.tooltip,
        title = _data$tooltip7.title,
        content = _data$tooltip7.content;
      return createTooltip(title, content, domQuery, callback);
    },
    dom: ['variableContainer', 'messageEditButton', '&0']
  };
  c[setVariableEditable] = {
    "do": function _do(id) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var VC = getVC();
      var variable = VC.getVariable(id);
      var nameField = variable.listElement.nameField;
      if (value) {
        VC.updateSelectedVariable(variable);
      } else {
        nameField.blur();
        VC.updateSelectedVariable(null, 'variable');
      }
    },
    state: function state(id) {
      return [id];
    },
    log: function log(id) {
      return [['id', id]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'setVariableEditable',
    restrict: function restrict(data, domQuery, callback) {
      Entry.Utils.blur();
      var VC = getVC();
      VC.updateSelectedVariable(null, 'variable');
      VC.getVariable(data.content[1][1]).listElement.addClass('activeForce');
      var _data$tooltip8 = data.tooltip,
        title = _data$tooltip8.title,
        content = _data$tooltip8.content;
      return createTooltip(title, content, domQuery, callback);
    },
    dom: ['variableContainer', 'variableEditButton', '&0']
  };
  c[setListEditable] = {
    "do": function _do(id) {
      var VC = getVC();
      var variable = VC.getList(id);
      // const { nameField } = variable.listElement;

      // nameField.removeAttribute('disabled');
      VC.updateSelectedVariable(variable);
      // nameField.focus();
    },
    state: function state(id) {
      return [id];
    },
    log: function log(id) {
      return [['id', id]];
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'setListEditable',
    restrict: function restrict(data, domQuery, callback) {
      Entry.Utils.blur();
      getVC().getList(data.content[1][1]).listElement.addClass('activeForce');
      var _data$tooltip9 = data.tooltip,
        title = _data$tooltip9.title,
        content = _data$tooltip9.content;
      return createTooltip(title, content, domQuery, callback);
    },
    dom: ['variableContainer', 'listEditButton', '&0']
  };
  c[variableSetName] = {
    "do": function _do(id, value) {
      var VC = getVC();
      VC.changeVariableName(VC.getVariable(id), value);
    },
    state: function state(id) {
      return [id, getVC().getVariable(id).getName()];
    },
    log: function log(id, value) {
      return [['id', id], ['value', value]];
    },
    restrict: function restrict(_ref7, domQuery, callback) {
      var tooltip = _ref7.tooltip,
        content = _ref7.content;
      _updateSelected(content);
      Entry.Utils.focusIfNotActive(domQuery);
      var tooltipTitle = tooltip.title,
        tooltipContent = tooltip.content;
      return createTooltip(tooltipTitle, tooltipContent, domQuery, callback, {
        noDispose: true
      });
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'variableSetName',
    dom: ['variableContainer', 'variableName', '&0']
  };
  c[listSetName] = {
    "do": function _do(id, value) {
      var VC = getVC();
      VC.changeListName(VC.getList(id), value);
    },
    state: function state(id) {
      return [id, getVC().getList(id).getName()];
    },
    log: function log(id, value) {
      return [['id', id], ['value', value]];
    },
    restrict: function restrict(_ref8, domQuery, callback) {
      var tooltip = _ref8.tooltip,
        content = _ref8.content;
      _updateSelected(content);
      Entry.Utils.focusIfNotActive(domQuery);
      var tooltipTitle = tooltip.title,
        tooltipContent = tooltip.content;
      return createTooltip(tooltipTitle, tooltipContent, domQuery, callback, {
        noDispose: true
      });
    },
    recordable: RECORDABLE.SUPPORT,
    undo: 'listSetName',
    dom: ['variableContainer', 'listName', '&0']
  };

  //utilities

  //if data has toJSON method
  //return data.toJSON()
  //else just return data as is
  function _toJSON(data) {
    return _.result(data, 'toJSON') || data;
  }
  function getVC() {
    return Entry.variableContainer;
  }
  function _updateSelected(content) {
    var VC = getVC();
    var vId = content[1][1];
    var v = VC.getVariable(vId) || VC.getList(vId);
    if (v) {
      VC.updateSelectedVariable(v);
    }
  }
  function _listActiveRestrictor(_ref9, domQuery, callback) {
    var tooltip = _ref9.tooltip,
      content = _ref9.content;
    _updateSelected(content);
    var tooltipTitle = tooltip.title,
      tooltipContent = tooltip.content;
    return createTooltip(tooltipTitle, tooltipContent, domQuery, callback);
  }
})(Entry.Command);